'use client';

import CheckIcon from '@/components/icons/CheckIcon';
import styles from './CategoryCard.module.css';

// add category through props
// pass select category handler

interface ICategoryCardProps {
  categoryName: string;
  isSelected: boolean;
  handleClick: () => void;
}

export const CategoryCard = ({ categoryName, isSelected, handleClick }: ICategoryCardProps) => {
  return (
    <div className={`${styles.card} ${isSelected ? styles.selected : ''}`} onClick={handleClick}>
      <div className="flex flex-row justify-end">
        {isSelected && (
          <div className="h-5 w-5">
            <CheckIcon />
          </div>
        )}
      </div>
      <div className="flex flex-col items-start">
        <span>🦅</span>
        <span>{categoryName}</span>
      </div>
    </div>
  );
};
